// Cart Auto-Add setup
window.addEventListener("abra:cart:changed", () => {
    const cartItemsEl = document.querySelector("cart-items-component");
    const sectionId = cartItemsEl?.dataset?.sectionId;

    fetch("/cart.js" + (sectionId ? "?sections=" + sectionId : ""))
        .then((r) => r.json())
        .then((cart) => {
            document.dispatchEvent(
                new CustomEvent("cart:update", {
                    bubbles: true,
                    detail: {
                        resource: cart,
                        sourceId: "abra-cart-changed",
                        data: {
                            itemCount: cart.item_count,
                            source: "abra-cart-changed",
                            sections: cart.sections || {},
                        },
                    },
                })
            );
        });
});